import instance from "@/plugins/axios";
import { ResponseResult } from "@/core/models/response-result";
import {
  AbstractUserRemoteDataSource,
  GetUsersParams,
  updateUserRolesParams,
} from "@/modules/users/remote/AbstractUserRemoteDataSource";
import { User } from "@/modules/users/models/user";
import { UserRole } from "../models/user-role";
import { TableState } from "@/core/models/table-state";

export class UserRemoteDataSource implements AbstractUserRemoteDataSource {
  async getUsers(params: GetUsersParams): Promise<ResponseResult> {
    try {
      const response = (
        await instance.get<ResponseResult<any>>("Administration/users", {
          params,
        })
      ).data;

      if (!response.isSuccess) return response;

      response.data = this.convertFromJsonToTableState(response.data);
      return response;
    } catch (error) {
      console.error(error);
      return ResponseResult.defaultError(error);
    }
  }

  async getGeneralInformation(): Promise<ResponseResult> {
    try {
      const response = (
        await instance.get<ResponseResult<any>>("Administration/users/summary")
      ).data;

      return response;
    } catch (error) {
      console.error(error);
      return ResponseResult.defaultError(error);
    }
  }
  async getUsersRoles(): Promise<ResponseResult> {
    try {
      const response = (
        await instance.get<ResponseResult<any>>("Administration/users/roles")
      ).data;
      if (!response.isSuccess) return response;

      response.data = this.convertFromJsonToUserRoleList(response.data);

      return response;
    } catch (error) {
      console.error(error);
      return ResponseResult.defaultError(error);
    }
  }

  async updateUserRoles(
    userId: string,
    params: updateUserRolesParams,
  ): Promise<ResponseResult> {
    try {
      const response = (
        await instance.put<ResponseResult<any>>(
          "Administration/users/" + userId + "/roles",
          params,
        )
      ).data;

      return response;
    } catch (error) {
      console.error(error);
      return ResponseResult.defaultError(error);
    }
  }

  convertFromJsonToTableState(data: any): TableState<User> {
    return {
      pageNumber: data.pageNumber,
      pageSize: data.pageSize,
      totalItems: data.totalItems,
      totalPages: data.totalPages,
      items: this.convertFromJsonToUserList(data.items),
    };
  }

  convertFromJsonToUserList(data: any[]): User[] {
    return data.map((item) => this.convertFromJsonToUser(item));
  }

  convertFromJsonToUser(data: any): User {
    return {
      id: data.id,
      email: data.email,
      firstName: data.firstName,
      lastName: data.lastName,
      enabled: data.enabled,
      createdAt: data.createdAt,
      federationProvider: data.federationProvider,
      username: data.username,
      effectiveRoles: data.effectiveRoles,
      isFederated: data.isFederated,
      roles: data.roles,
    };
  }

  convertFromJsonToUserRoleList(data: any[]): UserRole[] {
    return data.map((item) => this.convertFromJsonToUserRole(item));
  }

  convertFromJsonToUserRole(data: any): UserRole {
    return {
      id: data.id,
      name: data.name,
      description: data.description,
      composite: data.composite,
    };
  }
}
